import { PureComponent } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { logout } from './actionCreators';

const mapDispatchToProps = (dispatch) => ({
  onLoad: () => logout(dispatch),
});

class Logout extends PureComponent {
  componentDidMount() {
    const { onLoad } = this.props;
    onLoad();
  }

  render() {
    return <div>You are now logged out</div>;
  }
}

Logout.propTypes = {
  onLoad: PropTypes.func.isRequired,
};

export default connect(null, mapDispatchToProps)(Logout);
